import useTranslation from 'hooks/useTranslation'
import PlaceInput from 'components/inputs/Place'
import InputTime from 'components/inputs/Time'
import InputDate from 'components/inputs/Date'
import Modal from 'components/Modal/Modal'
import { Form, Step, StepKeys } from '..'
import React, { useState } from 'react'

interface AddCeremonyModalProps {
  stepKey: StepKeys
  form: Form
  setForm: React.Dispatch<React.SetStateAction<Form>>
  onClose: base.BasicFunc
}

interface Errors {
  place?: string
  address?: string
  date?: string
  time?: string
}

const AddCeremonyModal: React.FC<AddCeremonyModalProps> = ({ stepKey, form, setForm, onClose }) => {
  const [values, setValues] = useState<Step>(form.steps[stepKey] || {} as Step)
  const [errors, setErrors] = useState<Errors>({})

  const { t } = useTranslation('obituary')
  const updateValue = (key: keyof Step, value: any) => {
    setValues(prev => ({ ...prev, [key]: value }))
  }

  const validateForm = () => {
    if (!values.place || !values.address || !values.date || !values.time) {
      setErrors({
        place: values.place ? undefined : 'Podaj miejsce',
        address: values.address ? undefined : 'Podaj adres',
        date: values.date ? undefined : 'Podaj datę',
        time: values.time ? undefined : 'Podaj godzinę',
      })
    } else {
      setForm(prev => ({ ...prev, steps: { ...prev.steps, [stepKey]: values } }))
      onClose()
    }
  }

  return (
    <Modal
      title={t(stepKey)}
      onClose={onClose}
      primaryButton='Zapisz'
      primaryButtonAction={validateForm}
      secondaryButton='Anuluj'
      secondaryButtonAction={onClose}>
      <div className='modal__form'>
        <div className='myInput'>
          <label>{errors.address || 'Adres do nawigacji'}</label>
          <PlaceInput
            value={values.address || ''}
            error={errors.address}
            setValue={address => {
              if (typeof address === 'string') {
                setValues(prev => ({
                  ...prev,
                  address,
                  gps_latitude: undefined,
                  gps_longitude: undefined,
                }))
              } else {
                setValues(prev => ({
                  ...prev,
                  address: address.formattedAddress,
                  place: address.displayName.text,
                  gps_latitude: address.location.latitude,
                  gps_longitude: address.location.longitude,
                }))
              }
            }}
          />
        </div>

        <InputDate
          today
          value={values.date || ''}
          onChange={(date) => {
            updateValue('date', date)
          }}
          label={errors.date || 'Data'}
          error={errors.date}
        />

        <InputTime
          value={values.time || ''}
          onChange={(time) => {
            updateValue('time', time)
          }}
          label={errors.time || 'Godzina'}
          error={errors.time}
        />

        <div className='myInput'>
          <label>{errors.place || 'Opisz miejsce'}</label>
          <input
            className={errors.place ? 'error' : ''}
            type='text'
            placeholder='np. Dom pogrzebowy Sala A'
            value={values.place || ''}
            onChange={(e) => {
              updateValue('place', e.target.value)
            }}
          />
        </div>

        <div className='myInput'>
          <label>Dodaj opis (opcjonalnie)</label>
          <input
            type='text'
            placeholder='np. wejście od ul. Jana Pawła'
            value={values.place_description || ''}
            onChange={(e) => {
              updateValue('place_description', e.target.value)
            }}
          />
        </div>
      </div>
    </Modal>
  )
}

export default AddCeremonyModal